import { render, staticRenderFns } from "./Grade10ResultTable.vue?vue&type=template&id=7496fdf4&"
import script from "./Grade10ResultTable.vue?vue&type=script&lang=js&"
export * from "./Grade10ResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports